import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'ItemStock';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $showByItemAndWarehouse = ActionCreator.Async(MODULE, 'ShowByItemAndWarehouse', (itemid, warehouseId) => {
  return async (dispatch) => {
    dispatch($processing($showByItemAndWarehouse.OPERATION));

    return await Rest.GET(`${API_URL}/wms/stock`, {item_id: itemid, warehouse_id: warehouseId})
      .then((response) => {
        const data = response?.data?.[0]

        dispatch($showByItemAndWarehouse.success({ response: data }));
        return data;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($showByItemAndWarehouse.OPERATION)));
  };
});
